var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"account-card"},[_c('Avatar',{staticClass:"card-image",attrs:{"height":30}}),_c('span',{staticClass:"text6"},[_vm._v(_vm._s(_vm.fullName))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }